export default __webpack_public_path__ + "static/media/alerts.6f78e1f9.svg";